import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-employees/src/assets/icon-fencing.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')